import { BigIntWithDecimals, USD_DECIMALS } from '@silo/types';
import { parseBigIntWithDecimals } from '@silo/utils';

type CoinGeckoResponse = Record<string, { usd: number }>;

export const queryCoinGeckoPrice = async (id: string): Promise<BigIntWithDecimals> => {
  const response = await fetch(`https://api.coingecko.com/api/v3/simple/price?ids=${id}&vs_currencies=usd`);

  const {
    [id]: { usd },
  } = (await response.json()) as CoinGeckoResponse;

  return parseBigIntWithDecimals(USD_DECIMALS)(`${usd}`);
};
